module.exports = __webpack_public_path__ + "static/media/trolley.7926d47d.svg";